import React, { useState } from "react";
import Childdetails from "./Childdetails";
import "../component/css/Navbar.css";

import Parentdetails from "./Parentdetails";
import Submission from "./Submission";
import { useSelector } from "react-redux";

function Navbar() {
  const [currentView, setCurrentView] = useState(1);
  const schooldata = useSelector((state) => state.schoolDetails);
  const keywordLabels = useSelector((state) => state.keywordLabels);
  const childLabel = keywordLabels?.child || "Child";
  const steps = [
    { id: 1, label: `${childLabel} Details`, description: "Basic information" },
    { id: 2, label: "Parent Details", description: "Contact information" },
    { id: 3, label: "Submission", description: "Final review" },
  ];
  const activeStep = steps.find((step) => step.id === currentView) || steps[0];

  const renderView = () => {
    switch (currentView) {
      case 1:
        return <Childdetails Forward={handleNext} />;
      case 2:
        return <Parentdetails Back={handleBack} Forward={handleNext} />;
      case 3:
        return (
          <Submission
            initalScreen={getToinitalForm}
            Back={handleBack}
            Forward={handleNext}
          />
        );
      default:
        return <Childdetails Forward={handleNext} />;
    }
  };

  const isActive = (stepId) => {
    if (stepId === currentView) return "active";
    if (stepId < currentView) return "complete";
    return "";
  };

  const handleNext = () => {
    setCurrentView((view) => Math.min(view + 1, steps.length));
  };

  const getToinitalForm = () => {
    setCurrentView(1);
  };

  const handleBack = () => {
    setCurrentView((view) => Math.max(view - 1, 1));
  };

  return (
    <div className="navbar-head">
      <aside className="navbar-child tp-pding" aria-label="Enrollment progress">
        <div className="enrollment-brand">
          <div className="algn">
            {schooldata?.photo ? (
              <img
                src={schooldata.photo}
                alt={`${keywordLabels?.orgName || "School"} logo`}
                className="navbar-img"
              />
            ) : (
              <div className="navbar-img navbar-img-fallback" aria-hidden="true">
                {childLabel.charAt(0)}
              </div>
            )}
          </div>
          <div className="enrollment-brand-copy">
            <p>{keywordLabels?.orgName || "Sparkle"}</p>
            <strong>{childLabel} Enrollment</strong>
          </div>
        </div>

        <div className="enrollment-progress">
          <span>
            Step {currentView} of {steps.length}
          </span>
          <div className="enrollment-progress-track">
            <div
              className="enrollment-progress-bar"
              style={{ width: `${(currentView / steps.length) * 100}%` }}
            />
          </div>
        </div>

        <div className="Link-tag">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`Link font-fmly ${step.id === currentView ? "current-step" : ""}`}
              aria-current={step.id === currentView ? "step" : undefined}
            >
              <span className={isActive(step.id)}>{String(step.id).padStart(2, "0")}</span>
              <label className="child-health-details">
                {step.label}
                <small>{step.description}</small>
              </label>
            </div>
          ))}
        </div>
      </aside>

      <main className="navbar-child2">
        <div className="mobile-step-summary">
          <span>{activeStep.description}</span>
          <strong>{activeStep.label}</strong>
        </div>
        {renderView()}
      </main>
    </div>
  );
}

export default Navbar;
